import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FileActionFunction, FileItemType } from '../../types/communication/communicationDataType'
import { FileItemContent, FileListItem, FilePreviewImg } from '../styled/File.style';
import { useParams } from 'react-router-dom';
import { faFileLines } from '@fortawesome/free-regular-svg-icons';

import {
    LFileNameText,
    LFileNameAndBinContainer,
    FilePreviewIconContainer
} from '../styled/File.style';

import FileImgFullPageCmp from './FileImgFullPageCmp';

import linearTrashBin from '../../assets/img/linear_trashbin.svg';
import { isPdfFile } from '../../utils/utils-files';
import DeletePhotoCmdItem from './DeletePhotoCmdItem';
import ResizerIconContainer from './ResizerIconContainer';
import CameraFileImgFullPageCmp from './CameraFileImgFullPageCmp';

interface FileItemCmpProps {
    file?: FileItemType
    deleteFile: FileActionFunction
    fullPageCanDelete?: boolean
    hasResizer?: boolean
    previewCustomClass?: string
    isCameraFileImage?: boolean
    titleImageDetail?: string
    companyName?: string;
    alreadySentDocIds?: string[];
    deleteLabelPresent?: boolean;
}

const FileItemCmp = (props: FileItemCmpProps) => {
    const { file, deleteFile, fullPageCanDelete,
        hasResizer, previewCustomClass, isCameraFileImage,
        titleImageDetail, companyName, alreadySentDocIds,
        deleteLabelPresent } = props
    const { token } = useParams();
    const [showFullpageImage, setShowFullpageImage] = useState<boolean>(false);
    const previewURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/download-attachment/${file?._id}`;
    const isLinear = companyName === "LINEAR";

    const [canDelete, setCanDelete] = useState(true)
    const isPdf = isPdfFile(file?.mimetype)
    const downloadURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/download-attachment/${file?._id}`;
    const companyClassName = companyName?.toUpperCase() || '';

    useEffect(() => {
        if (isLinear &&
            (alreadySentDocIds && file?._id && alreadySentDocIds.indexOf(file._id) >= 0)
        ) {
            setCanDelete(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [file?._id])

    const deleteFileHandler = () => {
        deleteFile(file);
        setShowFullpageImage(false)
    }

    const getFileIconCmp = () => {
        if (!file?._id) {
            return null
        }
        return isPdf ?
            <a target="_blank" href={downloadURL} rel="noreferrer">
                <FilePreviewIconContainer
                    className={companyClassName}>
                    <FontAwesomeIcon icon={faFileLines} />
                </FilePreviewIconContainer>
            </a>
            :
            <FilePreviewImg src={previewURL} alt="Foto contesto preview" />
    }

    const clickOnFileMiniature = () => {
        if (!isPdf) {
            setShowFullpageImage(true);
        }
    }

    return (
        <>
            {!isCameraFileImage && showFullpageImage && file && <FileImgFullPageCmp
                deleteHandler={fullPageCanDelete && canDelete ? deleteFileHandler : undefined}
                file={file} close={() => setShowFullpageImage(false)}
                companyName={companyName} />}
            {isCameraFileImage && showFullpageImage && file && <CameraFileImgFullPageCmp
                file={file} close={() => setShowFullpageImage(false)}
                previewCustomClass={previewCustomClass}
                titleImageDetail={titleImageDetail}
            />}

            <FileListItem
                key={file?._id || file?.name}
                className={`${companyName} file-item`}
            >
                <FileItemContent
                    onClick={clickOnFileMiniature}
                    className={`${companyClassName} file-item-preview-img-content`}>
                    {file?.metadata?.isLoading ?
                        <FontAwesomeIcon icon={faSpinner} className="fa-spin" /> :
                        getFileIconCmp()}
                    {
                        hasResizer && <ResizerIconContainer />
                    }
                </FileItemContent>

                {isLinear && file?.name && <LFileNameAndBinContainer>
                    <LFileNameText>{file?.name}</LFileNameText>
                    {canDelete && <img
                        src={linearTrashBin}
                        alt="TrashBin"
                        style={{ width: "21px" }}
                        onClick={() => deleteFile(file)}
                    />}
                </LFileNameAndBinContainer>}
                {deleteLabelPresent && canDelete && !file?.metadata?.isLoading && <DeletePhotoCmdItem
                    onClickHandler={() => deleteFile(file)} />
                }
            </FileListItem>
        </>
    );
};

export default FileItemCmp;
